import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { GrFormNext, GrFormDown, GrFormUp } from "react-icons/gr";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import newRequest from "../../utils/newRequest";

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionItems = [
    {
      title: "What is an asset?",
      content: `An asset is something a business or organization uses as part of its operations. Common assets include:
IT equipment
Tools
Vehicles
Furniture
Buildings
Asset Panda's pricing is based on how many assets you'd like to track, and our configurable system can be set up to track just about anything.`,
    },
    {
      title: "What if I don't know how many assets I have?",
      content:
        "Our experts will be happy to work with you to determine what asset count will work best for you. If you find that you need to track more assets down the road you can upgrade your account at any time.",
    },
    {
      title: "Do I need to buy a barcode scanner?",
      content:
        "Nope! Forget about buying expensive barcode scanning hardware.One of the biggest advantages of the Asset Panda system is the integrated barcode scanning function included in the mobile app. Any user with a mobile device can quickly search, update, and maintain asset records to improve the accuracy of your data.",
    },
    {
      title: "Do I need to buy barcode labels?",
      content: `If you want to print your own barcodes, you can easily do so with the barcode generator built into Asset Panda's web app.
If you need barcodes that can stand up to heat, moisture, chemicals, or other environmental hazards, Asset Panda has partnered with a team of experts who can help you out.`,
    },
  ];

  const { t, i18n } = useTranslation();
  const navigate=useNavigate()
    const { isLoading, error, data: FaqsData } = useQuery("fetchAllFaqs", fetchFeaturesData);

  async function fetchFeaturesData() {
    const response = await newRequest.get("/getAllfaqs");
    return response?.data.filter(item => item.status === 1) || [];
  }

     const {data: FaqsDataheading } = useQuery("fetchAllFaqsheading", fetchFeaturesheadingData);

  async function fetchFeaturesheadingData() {
    const response = await newRequest.get("/getAllheadings");
    return response?.data.filter((item) => item.status === 1) || [];
  }

   const thirdItem = FaqsDataheading?.[2];

  return (
    <div className="w-full py-10 mt-14 px-10 bg-[#f7f9fd]">
      <h2 className="text-4xl text-center leading-tight font-bold text-[#1d2331] my-10 font-lato">
         {i18n.language === "ar" ? thirdItem?.title_ar || '' : thirdItem?.title || ""}
      </h2>
      <div className="hs-accordion-group space-y-3">
        {isLoading ? (
          <div>Loading...</div>
        ) : error ? (
          ""
        ) : (
          FaqsData.map((item, index) => (
            <div
              key={index}
              className={`hs-accordion text-xl font-bold ${
                openIndex === index ? "active" : ""
              } ${
                openIndex === index ? "border-t-4 border-[#3d67d1]" : ""
              } bg-white rounded-lg shadow-md p-5 ${
                i18n.language === "ar" ? "direction-rtl" : "direction-ltr"
              }`}
            >
              <button
                className={`hs-accordion-toggle hs-accordion-active:text-blue-600 py-3 text-2xl inline-flex items-center justify-between gap-x-3 w-full font-semibold text-start text-gray-800 hover:text-gray-500 rounded-lg ${
                  openIndex === index ? "hs-accordion-active" : ""
                } ${openIndex === index ? "text-[#2b4892]" : "text-[#2f3641]"}`}
                onClick={() => handleToggle(index)}
                aria-controls={`hs-basic-with-title-and-arrow-stretched-collapse-${index}`}
              >
                {i18n.language === "ar" ? item?.title_ar : item?.title}
                {openIndex === index ? (
                  <GrFormUp className="size-4" />
                ) : (
                  <GrFormDown className="size-4" />
                )}
              </button>
              <div
                id={`hs-basic-with-title-and-arrow-stretched-collapse-${index}`}
                className={`hs-accordion-content w-full overflow-hidden transition-all duration-6000 ease-in-out ${
                  openIndex === index ? "max-h-screen" : "max-h-0"
                }`}
                aria-labelledby={`hs-basic-with-title-and-arrow-stretched-heading-${index}`}
              >
                <p className="p-4 text-[#596175] text-md">
                  <em>
                    {" "}
                    {i18n.language === "ar"
                      ? item?.description_ar
                      : item?.description}
                  </em>
                </p>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="flex justify-center">
        {/* <button
          // onClick={() => navigate('/get-barcode')}
          className="bg-[#f0452b] my-20 text-white mx-3 px-8 border border-[#f0452b] hover:bg-[#2b4892] hover:border-[#2b4892]  py-2 text-lg font-bold  rounded-md transition-all duration-300  transform "
        >
          View all FAQ
        </button> */}
      </div>
    </div>
  );
}

export default FAQSection;
